import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { FormBuilder, FormControl } from '@angular/forms';
import { FormValidations } from '../../../shared/form-validation/form-validation';
import { Title } from '@angular/platform-browser';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { Keyboard, KeyboardResizeMode } from '@awesome-cordova-plugins/keyboard/ngx';
import { PersonalDataService } from '../../service/personal-data.service';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';
import { TrackTypes } from '../../../shared/service/journey/tracks/model/track-types';
import { AnalyticsGA4PageService } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';
import { AnalyticsGA4PagesModel } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';

@Component({
  selector: 'app-date-birth',
  templateUrl: './date-birth.component.html',
  styleUrls: ['./date-birth.component.scss'],
})
export class DateBirthComponent extends DefaultPageComponent implements OnInit {

  public birthData = '';
  public idComponentName = 'documentDateBirth';
  placeholder = '00/00/0000';
  error = false;
  buttonEnable = false;
  textError = '';
  invalidErrorText = 'Data de nascimento inválida';
  idLabel = 'dataBirthLabel';
  label = 'data de nascimento';
  startStage = '';
  endStage = '';
  titleLabelPage = 'Quando você nasceu?';
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;

  dateBirthForm = this.formBuilder.group({
    docDateBirth: this.formBuilder.control('', [FormValidations.validationsDate])
  });

  headerId = 'date-birth';
  titlePage = 'Dados pessoais';

  constructor(
    public router: NavController,
    private personalDataService: PersonalDataService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private formBuilder: FormBuilder,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private keyBoard: Keyboard,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getTrack();
    this.keyBoard.setResizeMode(KeyboardResizeMode.Body);
  }

  /* istanbul ignore next */
  get docDateBirth() { return this.dateBirthForm.get('docDateBirth'); }

  /* istanbul ignore next */
  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest('documento_data_nascimento', 'dateOfBirth', 'personalData');
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = 'personal-data';

    if (this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL) {
      this.startStage = (track.getIndexPage(this.headerId, path)).toString();
      this.endStage = (track.getTotalPage(path)).toString();
    } else {
      this.startStage = (track.getIndexPage(this.headerId, path) - 1).toString();
      this.endStage = (track.getTotalPage(path) - 1).toString();
    }
  }

  analyticsData() {
    const it_pagename = this.analyticsPage?.birthDate;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathDataNascimento,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    /* tslint:disable:no-string-literal */
    this.personalDataService.setDocumentDateOfBirthData(this.birthData);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = 'Clique';
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.birthDate
    };

    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  getPageId(): string {
    return this.headerId;
  }

  errorMsg() {
    const control = this.dateBirthForm.get('docDateBirth') as FormControl;
    this.error = control.errors !== null;

    this.error ? this.buttonEnable = false : this.buttonEnable = true;

    if (control.errors !== null && control.errors.hasOwnProperty('dateInvalid')) {
      this.textError = this.invalidErrorText;
      this.edit = true;
      this.editFieldInvest('documento_data_nascimento', 'dateInvalid', 'personalData');
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data?.personalData?.dateOfBirth) {
      const date = this.journeyService.registratioJourney.data?.personalData?.dateOfBirth.substr(0, 10).split('-').reverse().join('/');
      this.birthData = date;
      this.dateBirthForm.controls.docDateBirth.setValue(date);
      this.errorMsg();
    }
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

}


